var map = {
	"./barbecue.png": "807d",
	"./buffet.png": "ff7a",
	"./dining-table.png": "7dd5",
	"./ellipsis.png": "b581",
	"./hotpot.png": "9779",
	"./ice-tea.png": "db31",
	"./supermarket.png": "a999",
	"./take-away.png": "f52b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d129";